import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  evergreenTitle: {
    marginBottom: 18,
    fontSize: 38,
  },
  container: {
    [theme.breakpoints.up("md")]: {
      marginBottom: 25,
    },
    [theme.breakpoints.down("md")]: {
      minHeight: 125,
      marginTop: 25,
      textAlign: "center",
    },
  },
  mobileCenteredText: {
    [theme.breakpoints.down("sm")]: {
      margin: "0 auto",
    },
  },
  desktopFlex: {
    [theme.breakpoints.up("md")]: {
      display: "flex",
      justifyContent: "flex-start",
      gap: 20,
    },
  },
  priceRange: {
    fontSize: 18,
    fontWeight: 600,
    lineHeight: "inherit",
  },
  pricingSkeleton: {
    [theme.breakpoints.up("md")]: {
      marginBottom: 37,
      textAlign: "center",
    },
  },
}));
